import getDefaultRoutingKey from './getDefaultRoutingKey';
import getUserMailboxId from './getUserMailboxId';
import { getUserPrimarySmtpAddress } from 'owa-session-store';
import MailboxInfo from '../schema/MailboxInfo';
import MailboxType from '../schema/MailboxType';
import getStore from '../store';

export default function getUserMailboxInfo(mailboxId?: string): MailboxInfo {
    const userMailboxInfoMap = getStore().userMailboxInfoMap;
    if (!userMailboxInfoMap || !userMailboxInfoMap.get(mailboxId)) {
        let userMailboxInfo = {
            type: MailboxType.UserMailbox,
            deprecatedMailboxId: mailboxId ? mailboxId : getUserMailboxId(),
            primarySmtpAddress: mailboxId ? mailboxId : getUserPrimarySmtpAddress(),
            routingKey: getDefaultRoutingKey(),
            returnModernConversationItems: false,
            requestOptions: null,
        };

        userMailboxInfoMap.set(mailboxId, userMailboxInfo);

        return userMailboxInfo;
    }

    return userMailboxInfoMap.get(mailboxId);
}
